import React from 'react';
import CardSummary from '../cards/CardSummary';

interface IProps {
  periodsSelectedData: any;
}

const StepCycle = ({ periodsSelectedData }: IProps) => (
  <CardSummary
    title="Resumen"
    items={[`Periodo: <b>${periodsSelectedData}</b>`]}
  />
);

export default StepCycle;
